/**
 * Mirrors `backend/lib/storefront-pricing.ts` for client UI (cards, PDP).
 * See docs/storefront-pricing-and-search.md for field meanings.
 */

export function resolveSellingPriceFromAvailability(
  price: number | null | undefined,
  unitCost: number
): number {
  if (price !== null && price !== undefined) {
    return Number(price);
  }
  return Number(unitCost);
}

export function strikethroughCompareAtPrice(
  sellingPrice: number,
  compareAtPrice: number | null | undefined
): number | null {
  if (compareAtPrice === null || compareAtPrice === undefined) return null;
  const ca = Number(compareAtPrice);
  const sell = Number(sellingPrice);
  if (!Number.isFinite(ca) || !Number.isFinite(sell)) return null;
  return ca > sell ? ca : null;
}
